import { createMemo } from 'solid-js';
import Button from '../../st-button/st-button';
import { requireAttendanceGridContext } from '../st-attendance-grid';
import { StatusVerification } from '../../../api';
import styles from '../st-attendance-grid.module.css';

export interface WeekHeaderProps {
    courseName: string;
    courseID: string;
    sectionName: string;
    periodNumber: string;
    sectionGU: string;
}

export function WeekHeader(props: WeekHeaderProps) {
    const ctx = requireAttendanceGridContext();

    const sectionStatus = createMemo(() => {
        const section = ctx.attendance[0]().find(s => s.sectionGU === props.sectionGU);
        return section?.status ?? StatusVerification.None;
    });

    const isConfirmed = () => sectionStatus() === StatusVerification.Accepted;
    const isReviewed = () => sectionStatus() !== StatusVerification.None;

    const handleConfirm = () => {
        ctx.handleConfirmSection(props.sectionGU);
    };

    return (
        <div class={styles['week-header']}>
            <div class={styles['week-header-buttons']}>
                <Button
                    type={isConfirmed() ? "default" : "success"}
                    onClick={handleConfirm}
                    enabled={ctx.isValidSchoolWeek[0]() && !ctx.isProcessingReport[0]() && !isReviewed()}
                >
                    {isConfirmed() ? 'Confirmed ✓' : 'Confirm'}
                </Button>
            </div>
            <div class={styles['week-header-info']}>
                <h3 class={styles['week-header-title']}>
                    Period {props.periodNumber} - {props.courseID} - {props.courseName}
                </h3>
                <div class={styles['week-header-subtitle']}>
                    Section: {props.sectionName}
                </div>
            </div>
        </div>
    );
}
